/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Table_FullInputs */



/**
* | output |
* | --- |
* | "Table already has 5 players" |
*
* @param {Err_Tournament_Table_FullInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_table_full = /** @type {((inputs?: Err_Tournament_Table_FullInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Table_FullInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La table a déjà 5 joueurs")
	if (locale === "es") return /** @type {LocalizedString} */ ("La mesa ya tiene 5 jugadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A mesa já tem 5 jogadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tavolo ha già 5 giocatori")
	return /** @type {LocalizedString} */ ("Table already has 5 players")
});